import { IterableElement } from 'type-fest'

import { Ticker } from '../ticker'
import { TRON_TOKEN_TICKERS } from './token-tickers'

export const TRON_TICKERS = [Ticker.TRX, ...TRON_TOKEN_TICKERS]

export type TronTickers = IterableElement<typeof TRON_TICKERS>
